import axios from 'axios'
import { PageDataResponse, DataArrayResponse,DataObjectResponse  ,PageResponse } from '../models/PageResponse'
import { Partner, PartnerName}  from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class PartnerService
{
    protected headers = {}
 protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }
    
    async getAll(page: number,limit: number,key: string ){
        let options = {
                headers: this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key:key
                }
            }
        
        const { data }  = await axios.get<PageDataResponse<Partner>>(`${apiUrl}/v1/partners/call`, options )
        
        return data;
    }

    async getById(id: number){
        let options = {
                headers:this.headers,
            }
        
        const { data }  = await axios.get<DataObjectResponse<Partner>>(`${apiUrl}/v1/partners/call/${id}`, options )
        
        return data;
    }

    async getAllName(){
        let options = {
                headers:this.headers,
            }
        
        const { data }  = await axios.get<DataArrayResponse<PartnerName>>(`${apiUrl}/v1/partners/name`, options )
        
        return data;
    }

    async getLimit(){
        let options = {
            headers: this.headers
        }
        const { data }   = await axios.get<DataArrayResponse<Partner>>(`${apiUrl}/v1/partners/limit`,options )
        return data;
    }

    async search(key:string){
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<Partner>>(`${apiUrl}/v1/partners/search`,options )
        return data;
    }

    async create(partner: Partner){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/partners/call`,JSON.stringify(partner),options )
        return data;
    }

    async update(partner: Partner){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/partners/call`,JSON.stringify(partner),options )
        return data;
    }

    async updateStatus(partner: Partner){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/partners/status`,JSON.stringify(partner),options )
        return data;
    }
}